export default function Filters({
  inEdit,
  selectBrand,
  chain,
  brand,
  country,
  chains,
  brands,
  countries,
  onChange,
  onClose,
}) {
  return (
    <div className="hotelFilters">
      <div className="hotelFiltersHead">
        <h3>Filters</h3>
        <button type="button" className="hotelTextBtn" onClick={onClose}>Close</button>
      </div>

      <label className="hotelCheck">
        <input
          type="checkbox"
          checked={inEdit}
          onChange={(e) => onChange({ inEdit: e.target.checked })}
        />
        <span>In The Edit</span>
      </label>

      <label className="hotelCheck">
        <input
          type="checkbox"
          checked={selectBrand}
          onChange={(e) => onChange({ selectBrand: e.target.checked })}
        />
        <span>Also eligible for the $250 Select Brand credit</span>
      </label>

      <label className="hotelField">
        <span>Chain</span>
        <select value={chain} onChange={(e) => onChange({ chain: e.target.value, brand: '' })}>
          <option value="">All chains</option>
          {chains.map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
      </label>

      <label className="hotelField">
        <span>Brand</span>
        <select value={brand} onChange={(e) => onChange({ brand: e.target.value })}>
          <option value="">All brands</option>
          {brands.map((b) => (
            <option key={b} value={b}>{b}</option>
          ))}
        </select>
      </label>

      <label className="hotelField">
        <span>Country</span>
        <select value={country} onChange={(e) => onChange({ country: e.target.value })}>
          <option value="">All countries</option>
          {countries.map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
      </label>
    </div>
  )
}
